<template lang="html">
<div class="v-scope-home-modulo-eventos">
<div class="eventos-view" v-if="eventos.length != 0">

    <h2 :style="style.colorBasic">{{$t('eventos.proximos')}}</h2>

    <section class="listado-eventos container row-start">


      <template v-if="!!data">
        <evento-el v-for="(evento, key) in eventos.slice(0,3)" :key="'evento-'+key" :data="evento"></evento-el>
      </template>

      <div class="contenedor-boton row-center">
        <router-link class="btn -solid-primary" :to="$t('enlaces.eventos')">{{$t('eventos.ver_mas')}}</router-link>
      </div>




    </section>


  </div>
</div>
</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex';

  import encabezado from '@/components/parts/encabezado';

  import evento from '@/components/views/eventos/evento-el'
  import eventoFake from '@/components/views/eventos/evento-el-fake'



  export default {
    name: 'modulo-eventos',
    mounted() {
      this.requestEventos();
    },
    methods: {
      ...mapActions(['requestEventos'])
    },
    computed: {
      ...mapGetters({
        data: 'getEventos',
        colors: 'basicColors',
        style: 'getStyles'
      }),
      eventos() {
        let eventos = new Array();

        if (this.data.length != 0) {
          this.data.forEach(evento => {
            let actual = new Date().getTime();
            let date = new Date(evento.fecha).getTime();
            if (date > actual) {
              eventos.push(evento);
            }
          });

          eventos = eventos.sort((a, b) => {
            let afecha = new Date(a.fecha).getTime();
            let bfecha = new Date(b.fecha).getTime();

            return (afecha - bfecha);

          });
          
          return eventos;

        }
      }
    },
    components: {
      'encabezado': encabezado,
      'evento-el': evento,
      'fake-evento-el': eventoFake
    }
  }
</script>



// WEBPACK FOOTER //
// submodules/dotia-base-fp/src/components/views/home/modulo-eventos.vue